import MatriPremiumPricing from '../components/MatriPremiumPricing'
import MatrimonyHeader from '../components/MatrimonyHeader'
import MatriProfileHero from "../components/MatriProfileHero"
import Footer from '../components/Footer'
import React from 'react'
import MatriHeader from '../components/MatriHeader'

function MatrimonyPricing() {
  return (
    <div>
        <MatriHeader />
        <MatriProfileHero />
        <MatriPremiumPricing />
        <Footer />
        
    </div>
  )
}

export default MatrimonyPricing
